import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'
import API from '../../../../api/api'

export const useUpdateNumberSubscription = (buildingId, onCallback) => {
  const { displaySnackbar } = useSnackbar()
  const { t } = useTranslation(['chat'])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const updateNumberSubscription = async (body) => {
    setIsLoading(true)
    try {
      await API.buyBuildingPhoneNumberByBuildingId(buildingId, body)
      displaySnackbar(t('chat:inboxSettings.subscriptionUpdatedSuccess'))
      onCallback()
    } catch (error) {
      displaySnackbar(t('chat:inboxSettings.subscriptionUpdateError'), true)
      setError(error)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    error,
    updateNumberSubscription,
  }
}

export const useCancelNumberSubscription = (buildingId, onCallback) => {
  const { displaySnackbar } = useSnackbar()
  const { t } = useTranslation(['chat'])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleCancelSubscription = async () => {
    setIsLoading(true)
    try {
      await API.cancelBuildingPhoneNumberByBuildingId(buildingId)
      onCallback()
      displaySnackbar(t('chat:inboxSettings.subscriptionCanceledSuccess'))
    } catch (error) {
      displaySnackbar(t('chat:inboxSettings.subscriptionUpdateError'), true)
      setError(error)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    error,
    handleCancelSubscription,
  }
}
